import { Component, DestroyRef, effect, ElementRef, HostListener, inject, Input, input, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { TranslocoService, isBrowser } from '@jsverse/transloco';
import { LangOptions, SelectItem } from '../../models/models';
import { FormControl } from '@angular/forms';
import { Observable, tap } from 'rxjs';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { isPlatformBrowser, NgClass } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-custom-selectbox',
  imports: [NgClass],
  templateUrl: './custom-selectbox.html',
  styleUrl: './custom-selectbox.scss'
})
export class CustomSelectbox implements OnInit {
  environment = environment;
  private eRef = inject(ElementRef);
  private transloco = inject(TranslocoService);
  private platformId = inject(PLATFORM_ID)
  private destroyRef = inject(DestroyRef)

  isBrowser = signal(isPlatformBrowser(this.platformId))
  isDropdownOpen = signal(false);
  readonly customClasses = input<string>('') 
  selectedItem = signal<SelectItem | null>(null);

  readonly options = input<SelectItem[]>([]);
  readonly control = input<FormControl>(new FormControl());
  readonly placeholder = input('Select an option')
  readonly label = input('');
  readonly isRequired = input(false);
  readonly name = input('dropdown')

  activeLang = toSignal(
    this.transloco.langChanges$ as Observable<LangOptions>,
    { initialValue: 'en' }
  );

  ngOnInit() {
    const initial = this.control().value;
    if (initial) {
      const matched = this.options().find(opt => opt.value === initial);
      this.selectedItem.set(matched || null);
    }
    this.control().valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        const selected = this.options().find(item => item.value === value);
        this.selectedItem.set(selected || null);
    })
  }

  selectItem(item: SelectItem) {
    this.control().setValue(item.value);
    this.selectedItem.set(item);
    this.isDropdownOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if(this.isBrowser()){
      if (!this.eRef.nativeElement.contains(event.target)) {
        this.isDropdownOpen.set(false);
      }
    }

  }
}
